import { render, staticRenderFns } from "./PrivateTeacherList.vue?vue&type=template&id=492d0d40&scoped=true&"
import script from "./PrivateTeacherList.vue?vue&type=script&lang=js&"
export * from "./PrivateTeacherList.vue?vue&type=script&lang=js&"
import style0 from "./PrivateTeacherList.vue?vue&type=style&index=0&id=492d0d40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492d0d40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
